import type { GameState } from '@pacmates/engine';

/**
 * True iff `cur.roundClearedCount` increased relative to `prev` -- the
 * server-authoritative signal that all pickups were just cleared and the
 * board respawned to a fresh level (SPEC.md §1.1: diff two real snapshots,
 * never a client-guessed transition e.g. off `pelletsRemaining` resetting).
 * `prev === null` (the very first snapshot this client has ever seen) is
 * never a "just cleared" transition -- there is nothing to diff against, so
 * a mid-round join or reconnect never spuriously flashes the banner.
 */
export function didLevelClear(prev: GameState | null, cur: GameState): boolean {
  if (!prev) return false;
  return cur.roundClearedCount > prev.roundClearedCount;
}
